/**
 * The block renderers are shared with every consuming app and live in the
 * ui-kit's `content-blocks` module — the admin preview renders content with
 * the exact components the apps ship. The one exception: seeded blocks the
 * apps render natively from live data get static admin-only stand-ins here,
 * so the preview shows the page as members will see it instead of a dashed
 * placeholder.
 */
import {
  DEFAULT_BLOCK_COMPONENTS,
  type BlockComponentRegistry,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/content-blocks';

import EventsCarouselPreview from './EventsCarouselPreview';
import MembershipCardPreview from './MembershipCardPreview';

export {
  getSectionChildLayoutClass,
  tokensToCssVars,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/content-blocks';

/** Kit renderers + the editor's static stand-ins for app-native blocks. */
export const DEFAULT_PREVIEW_REGISTRY: BlockComponentRegistry = {
  ...DEFAULT_BLOCK_COMPONENTS,
  eventsCarousel: EventsCarouselPreview,
  membershipCard: MembershipCardPreview,
};
